/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';
import { getCartOrder, getOrderItemExcludeSpecialProducts } from '../Cart/Cart-Selectors';
import { getFeatureFlags } from '../App/App-Selectors';

export const getExternalCartError = (state) => state?.mfeCheckout?.externalCart?.error || {};
export const getExternalCartList = (state) => state?.mfeCheckout?.externalCart?.list || [];
export const getExternalCartDTWByIds = (state) => state?.mfeCheckout?.externalCart?.deliveryMethodIds || {};
export const getExternalCartAccessToken = (state) => state?.mfeCheckout?.externalCart?.accessToken || {};
export const getExternalCartOrder = (state) => getCartOrder(state)?.externalCart || {};
const getExternalCartItemsInCart = (state) => getCartOrder(state)?.externalCart?.items || [];

export const isExternalCartProductInCart = createSelector([getExternalCartItemsInCart], (externalCartItems) => {
    let isItemAvailable = false;
    if (externalCartItems && externalCartItems.length > 0) {
        isItemAvailable = true;
    }
    return isItemAvailable;
});

// Review if there is HD(1019), SY(1018), WLF(1020) product in the cart.
export const isExtCartAvailableForProductsInCart = createSelector(
    [
        getOrderItemExcludeSpecialProducts,
        getFeatureFlags,
    ],
    (cartItems, featureFlags) => {
        const whichProductBrandSupportExtCart = featureFlags['which-product-brand-support-external-cart'];
        let isAllowed = true;
        cartItems.forEach((items) => (
            items.cartItems.forEach(
                (item) => {
                    if (isAllowed && !whichProductBrandSupportExtCart.allowed.includes(item.product.brandCode)) {
                        isAllowed = false;
                    }
                },
            )
        ));
        return isAllowed;
    });

export default {};
